import { useState } from 'react';
import { cn } from '../ui/cn';

export type FilterOption = { id: string; label: string; count: number };

const VISIBLE = 5;

/** Colonne de filtres par thème: cases à cocher avec effectifs, « Voir plus », « Effacer les filtres ». */
export default function InsightFilters({ title, options, selected, onToggle, onClear }: { title: string; options: FilterOption[]; selected: string[]; onToggle: (id: string) => void; onClear: () => void }) {
  const [all, setAll] = useState(false);
  const shown = all ? options : options.slice(0, VISIBLE);
  return (
    <div>
      <h2 className="border-b border-line pb-3 font-display text-[1.75rem] font-bold normal-case leading-tight tracking-normal text-black">{title}</h2>
      <ul className="mt-5 space-y-1">
        {shown.map((o) => {
          const disabled = o.count === 0 && !selected.includes(o.id);
          return (
            <li key={o.id}>
              <label className={cn('group flex cursor-pointer items-center gap-3 py-1.5 text-[1rem]', disabled ? 'cursor-not-allowed text-muted' : 'text-black')}>
                <input type="checkbox" className="peer sr-only" checked={selected.includes(o.id)} disabled={disabled} onChange={() => onToggle(o.id)} />
                <span aria-hidden className="flex h-4 w-4 shrink-0 items-center justify-center border border-charcoal bg-white transition-colors peer-checked:border-brand peer-checked:bg-brand peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-charcoal peer-disabled:border-line">
                  <svg viewBox="0 0 12 10" className="h-2.5 w-2.5 text-charcoal opacity-0 peer-checked:opacity-100 [input:checked~span_&]:opacity-100" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 5l3.5 3.5L11 1.5" /></svg>
                </span>
                <span className="transition-colors group-hover:text-brand-dark">{o.label}</span>
                <span className="text-sm text-ink">({o.count})</span>
              </label>
            </li>
          );
        })}
      </ul>
      {options.length > VISIBLE && (
        <button onClick={() => setAll((v) => !v)} className="mt-4 text-sm font-normal uppercase tracking-[0.094rem] text-ink hover:text-brand-dark">{all ? 'Voir moins' : 'Voir plus'}</button>
      )}
      {selected.length > 0 && (
        <button onClick={onClear} className="mt-8 border border-charcoal px-5 py-2.5 text-sm font-normal uppercase tracking-[0.094rem] text-charcoal transition-colors hover:bg-charcoal hover:text-white">Effacer les filtres</button>
      )}
    </div>
  );
}
